export class TranslateLanguagePageItem {
  idTranslateLanguagePageItem: number;
  idLanguagePageItem: number;
  idLanguage: number;
  text: string;
  locked: boolean;

  constructor(
    idTranslateLanguagePageItem: number,
    idLanguagePageItem: number,
    idLanguage: number,
    text: string,
    locked: boolean,
  ) {
    this.idTranslateLanguagePageItem = idTranslateLanguagePageItem;
    this.idLanguagePageItem = idLanguagePageItem;
    this.idLanguage = idLanguage;
    this.text = text;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateLanguagePageItem {
    return new TranslateLanguagePageItem(
      Number(raw.idTranslateLanguagePageItem),
      Number(raw.idLanguagePageItem),
      Number(raw.idLanguage),
      String(raw.text),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateLanguagePageItem {
    return new TranslateLanguagePageItem(
      this.idTranslateLanguagePageItem,
      this.idLanguagePageItem,
      this.idLanguage,
      this.text,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idLanguagePageItem: this.idLanguagePageItem,
      idLanguage: this.idLanguage,
      text: this.text,
    };
    if (this.idTranslateLanguagePageItem !== 0) {
      payload.idTranslateLanguagePageItem = this.idTranslateLanguagePageItem;
    }
    return payload;
  }
}
